import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterDrainageHouseholdDto } from "../../../../api";
import { WaterDrainageHouseholdColumns } from "../form/columns";

interface WaterDrainageHouseholdFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterDrainageHousehold: (values: CreateWaterDrainageHouseholdDto) => void;
}

export const WaterDrainageHouseholdForm: React.FC<WaterDrainageHouseholdFormProps> = ({ visible, setVisible, onCreateWaterDrainageHousehold }) => {
  const [form] = Form.useForm<CreateWaterDrainageHouseholdDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterDrainageHousehold}>
        {WaterDrainageHouseholdColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
